export default "__VITE_ASSET__BZETwKQU__";